'use client'

export function Contact() {
  return (
    <div className="min-h-screen py-8">
      <h1>Contact</h1>
      {/* content */}
    </div>
  )
}